<template>
    <v-container id="services">
        <h1 class="display-1 font-weight-bold mb-6 text-center">Nuestros Servicios</h1>
        <ServicesSection />
    </v-container>
</template>

<script>
import ServicesSection from '@/components/ServicesSection.vue';

export default {
    name: 'ServicesView',
    components: {
        ServicesSection,
    },
};
</script>

<style scoped>
/* Estilos específicos para la página de servicios */
</style>